import { render, staticRenderFns } from "./StudentReportTable.vue?vue&type=template&id=498ca4d4&scoped=true"
import script from "./StudentReportTable.ts?vue&type=script&lang=ts&external"
export * from "./StudentReportTable.ts?vue&type=script&lang=ts&external"
import style0 from "./student-report-table.scss?vue&type=style&index=0&id=498ca4d4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ca4d4",
  null
  
)

export default component.exports